import { Component, ContentChildren, EventEmitter, HostListener, Input, Output, QueryList, SimpleChanges } from '@angular/core';
import { designType } from '../../interfaces/enumDesignType';
import { sizeType } from '../../interfaces/enumSizeType';
import { StepComponent } from './step/step.component';

@Component({
  selector: 'rr-stepper',
  standalone: false,

  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent {
 @ContentChildren(StepComponent) steps!: QueryList<StepComponent>;
 @Output() onStepChange: EventEmitter<number> = new EventEmitter<number>();
 @Input()
 set currentStep(value: any) {
  this._currentStep = Number(value);
 }
 get currentStep(): number {
  return this._currentStep
 }
 _currentStep: number = 0;
 label: string | undefined;
 afterContentInit = false;
 
 ngAfterContentInit() {
  this.steps.forEach((step, index) => {
    step.step = index;
  })
  this.label = this.steps.get(this._currentStep)?.label;
  this.steps.forEach(step => step.currentStep = this._currentStep);
  this.afterContentInit = true;
 }

 ngOnChanges(changes: SimpleChanges): void {
  if(changes['currentStep']) {
    this._currentStep = Number(this.currentStep);
    if(this.afterContentInit) {
      this.updateStep(this._currentStep)
    }
  }
 }

 updateStep(newStep: number) {
  this._currentStep = newStep;
  this.onStepChange.emit(this._currentStep);
  this.steps.forEach(step => step.currentStep = newStep);
  this.label = this.steps.get(newStep)?.label;  
 }
}
